import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { api } from '../../App';

import { authActions } from '@r/auth/authSlice';
import { teacherActions } from '@r/teacher/teacherSlice';
import { Constructor, Loader, Reviews } from '@c';
import { useSocket, useActions, useWindowSize } from '@h';
import { toClassNames } from '@helps';

import CourseMenu from './CourseMenu/CourseMenu';
import { Test } from './Test';

import styles from './style.module.scss';

import { FiUser, FiX, FiStar } from 'react-icons/fi';

import katex from 'katex';
import 'katex/dist/katex.min.css';
window.katex = katex;

export function TeacherHome() {
    const { logoutStart, loginCheck } = useActions(authActions);
    const { saveSchemeStart } = useActions(teacherActions);
    const { generateSchemeStart } = useActions(teacherActions);
    const { regenerateSchemeStart } = useActions(teacherActions);
    const { schemePDFStart} = useActions(teacherActions)

    const { data: authData } = useSelector(({ auth }) => auth);
    const { isLoading, scheme, schemeId, courseName } = useSelector(
        ({ teacher }) => teacher
    );

    const [img, setImg] = useState('');
    const [showReview, setShowReview] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);

    const { width } = useWindowSize();
    const isWide =
        width === null ? window.innerWidth >= 1280 : width >= 1280;

    const { socket, initSocket } = useSocket();

    useEffect(() => {
        if (!socket) initSocket();

        return () => {
            if (socket) socket.disconnect();
        };
    }, [socket, initSocket]);

    useEffect(() => {
        if (authData) {
            api.get(`people/photo/${authData?.uid}`, {
                responseType: 'arraybuffer',
            })
                .then((response) =>
                    Buffer.from(response.data, 'binary').toString('base64')
                )
                .then((base64) => {
                    if (base64.trim() === '') {
                        setImg(null);
                    } else {
                        setImg('data:image/jpeg;base64,' + base64);
                    }
                });
        }
    }, [authData]);

    useEffect(() => {
        setShowReview(null);
    }, [schemeId]);

    useEffect(() => {
        if (authData === undefined) {
            loginCheck();
        }
    }, [authData, loginCheck]);

    const openInNewTab = (type) => {
        if (!schemeId) return;

        const url = `${window.location.origin}/teacherhome/preview?courseId=${schemeId}&type=${encodeURIComponent(
            type || ''
        )}`;
        window.open(url, '_blank');
        setPreviewOpen(false);
    };

    if (authData === undefined) {
        return (
            <div className={styles.wrapper}>
                <Loader color="#007aff" />
            </div>
        );
    }

    if (authData === null) {
        return <Redirect to="/teacher" />;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.header_top}>
                    <div className={styles.name}>
                        {authData.lastname} {authData.firstname}{' '}
                        {authData.patronymic}
                    </div>
                    <div className={styles.courseTitle}>{courseName}</div>
                </div>
                <div className={styles.avatar}>
                    {img ? (
                        <img src={img} alt="o_O" />
                    ) : (
                        <FiUser color="rgb(51, 135, 247)" />
                    )}
                </div>
                <button onClick={() => logoutStart()} className={styles.exit}>
                    Выйти
                </button>
            </div>
            <div
                className={toClassNames(
                    styles.content,
                    previewOpen && isWide && styles.content_split
                )}
            >
                <CourseMenu />
                {scheme && (
                    <Constructor
                        initElements={scheme.scheme ? scheme.scheme : []}
                        onSave={(els) =>
                            els &&
                            saveSchemeStart({ schemeId, data: { scheme: els } })
                        }
                        
                        onPDF={(els) =>
                            els &&                            
                            schemePDFStart({ schemeId , data: {"comment": null, "courseName": courseName}})
                        }
                        onGenerate={(els) =>                         
                            generateSchemeStart({ schemeId , data: {"force": els.force, "comment": els.comment === '' ? null : els.comment, "courseName": courseName}})
                        }
                        _onRegenerate={(data) =>
                            data &&                            
                            regenerateSchemeStart({ schemeId , data: {"data": data, "scheme": scheme}})
                        }
                        disabled={isLoading}
                        className={styles.constructor}
                        style={
                            previewOpen && isWide
                                ? { width: 'auto', flex: 1, minWidth: 0 }
                                : {}
                        }
                        onReviews={() => setShowReview(schemeId)}
                    />
                )}
                <Test
                    open={previewOpen}
                    onOpenChange={setPreviewOpen}
                    isWide={isWide}
                    onOpenInTab={openInNewTab}
                />
                <div
                    className={styles.reviews_container}
                    style={{
                        display: showReview ? 'block' : 'none',
                    }}
                >
                    <div className={styles.header}>
                        <div className={styles.title}>
                            <span>Отзывы</span>
                            {scheme?.rating ? (
                                <div>
                                    (<span>{scheme.rating}</span>
                                    <FiStar />)
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                        <FiX
                            size={30}
                            className={styles.close}
                            onClick={() => setShowReview(null)}
                        />
                    </div>
                    <div className={styles.reviews}>
                        <Reviews themeId={schemeId} />
                    </div>
                </div>
            </div>
        </div>
    );
}
